// extracted by mini-css-extract-plugin
export default {"modalSmall":"CloseConfirmationModal_modalSmall__e4oJ3"};